import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { LoginPopup } from '../LoginPopup';

const loginPopupId = uuid();

export const showLoginPopupAction = ({ onClose, onLogin, title } = {}) => addPopupAction({
    id: loginPopupId,
    component: LoginPopup,
    layer: LAYER.LOGIN,
    onLogin,
    onClose,
    title
});
